
import { Component, Vue, Prop } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
import { generateMetaInfo, getServiceJsonLd } from "@/utils/seo";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb
  }
})
export default class GrowthCamp extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "科研院 | 企业创始人与高管共同学习科学经营的实践社群 - 光华赋能",
      description:
        "光华科学经营研究院（科研院）是企业创始人与高管共同学习用科学经营实现高质量发展的实践社群。通过课堂共学、企业私董会、对标管理工具，帮助企业破解成长瓶颈。",
      keywords:
        "科研院,科学经营研究院,企业创始人培训,高管学习社群,BLM,BSC,企业对标管理,光华赋能",
      path: "/research-institute",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "BLM科学经营" },
        { name: "科研院" }
      ],
      jsonLd: getServiceJsonLd({
        name: "光华科学经营研究院",
        description:
          "企业创始人与高管共同学习用科学经营实现高质量发展的实践社群，提供课堂共学、私董会、对标管理等服务。",
        category: "高管学习社群"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/9b34cdaddc94102ffb5d686c169d3bee.png";
  pic2 = "/img/bf11863009c67736f60aa23af63ff374.png";
  pic3 = "/img/d80616f61491c2219103b802a7c9f29a.png";
  companyArr: any = [];
  List = [
    { title: "BLM科学经营", url: "" },
    { title: "科研院", url: "" }
  ];
  created() {
    this.initData();
  }
  initData() {
    // let companyArr0 = [];
    // let companyArr1 = [];
    // console.log(123456);
    // for (let index = 1; index < 13; index++) {
    //   companyArr0.push({
    //     img: require("@/assets/big-grow-activity/big-grow-activity" +
    //       index +
    //       ".png")
    //   });
    // }
    // for (let index = 13; index < 25; index++) {
    //   companyArr1.push({
    //     img: require("@/assets/big-grow-activity/big-grow-activity" +
    //       index +
    //       ".png")
    //   });
    // }
    // this.companyArr.push(companyArr0);
    // this.companyArr.push(companyArr1);
    // console.log("companyArr", this.companyArr);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute("content", "BLM科学经营，大增长营，科研院");
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "以“科学经营”系统理论为底座，围绕企业高质量发展的核心，基于企业战略规划而设计学习方案，以终为始，有效学习，集中力量，高效学习，统一团队科学经营主线，助力企业力出一孔；BSC，BSC平衡积分卡，分拆对，业务视角、领导力，价值观，分目标，拆动作，对能力，差距分析，战略意图，市场洞察，创新焦点，业务设计，关键任务，正式组织，人才，市场结果，财务，客户，内部流程，学习与成长"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
